import { Location } from '@angular/common';
import { NgForm, FormBuilder } from '@angular/forms';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

//shared libs
import { AppCodeGroup, ControlsParams } from '../../shared';
import { EntityService, ModalService, ToastService, ControlsComponent, SelectizeComponent, Options, SelectizeMode, SelectizeService, Message } from '../../blocks';
import { SpecialService } from '../../hospitalSetup/specialties/special.service';

//services
import { UsersPrivilege, UsersPrivilegeService, UsersService } from './usersPrivilege.service';
//services
import { ServiceSetting, ServiceSettingService } from '../../pricing/services-setting/services-setting.service';
import { User, UserService } from '../userData';
import { ClinicService, ClinicServiceService } from '../../hospitalSetup/clinic-service/clinic-service.service';

@Component({
  selector: 'sanabel-usersPrivilege',
  templateUrl: './usersPrivilege.component.html',
  providers: [UsersPrivilegeService]
})


export class UsersPrivilegeComponent implements OnInit {

  /*****************************field area******************************/
  pageSize: number = 7;
  totalRecords: number = 0;
  serviceSettingSearchKey: string;
  saveAndNewFlag = true;
  services: any[];
  specialServices: ClinicService[] = [];

  controlsParams;


  /***************************************Selectize Area*****************************************************/
  //specials
  levelNumber: number = 1;
  parentCode: number = null;
  selectizeServicesOptions: Options;
  selectizeServicesOptionsLevTwo: Options;
  serviceList: ServiceSetting[] = [];
  levelBreadcrumbArray: ServiceSetting[] = [];
  @ViewChild('parentServiceSelectize') selectizeServices: SelectizeComponent;
  codeListServices: Observable<Array<any>>;
  lastServicesArray: any[] = [];
  lastServicesArrayLevTwo: any[] = [];
  serviceCode: number = null;
  userServiceObj: UsersService[] = [];
  servicesOfuser: any[];
  ID: number;
  seclogins: any[];
  secloginLevTwo: any[];
  allData: any[];



  onServicesSelected(selectedItem: ServiceSetting): void {

    this.parentCode = selectedItem.serviceCode;
    this.levelNumber += 1;
    if (this.levelNumber < 3) {
      this.levelBreadcrumbArray.push(selectedItem);

      this.clearselectize();
    } else {
      this.onChildServiceClicked(selectedItem);
      this.clearselectize();
    }

  }
  //////////////////////////////level 2 //////////////////
  onServicesSelectedLevTwo(selectedItem: ServiceSetting): void {

    this.onChildServiceClickedLevTwo(selectedItem);
    //  this.levelBreadcrumbArray.push(selectedItem);
    this.clearselectize();
  }
  onChildServiceClickedLevTwo(selectedItem: any): void {
    this.serviceCode = selectedItem.serviceCode;
    this.getListServicesLevTwo(selectedItem.serviceCode);
  }

  //get Services by level no
  getListServicesLevTwo(serviceCode: number) {
    this.lastServicesArrayLevTwo = [];
    this.codeListServices = this._usersPrivilegeService.getServices(this.serviceCode);
    this.codeListServices.subscribe(s => {
      s['data'].forEach(a => this.lastServicesArrayLevTwo.push(a));
    });
  }
  /////////////////////////end lev2.//////////////

  ///////////to get table
  onChildServiceClicked(selectedItem: any): void {

    this.serviceCode = selectedItem.serviceCode;
    this.getListServices(selectedItem.serviceCode);
  }

  //get Services by level no
  getListServices(serviceCode: number) {
    this.lastServicesArray = [];
    this.codeListServices = this._usersPrivilegeService.getServices(this.serviceCode);
    this.codeListServices.subscribe(s => {
      s['data'].forEach(a => this.lastServicesArray.push(a));
    });
  }

  clearselectize() {
    this.selectizeServices.clear();
    this.selectizeServices.clearItems();
    //this.searchSelectizeServices('');
    // this.searchSelectizeServicesLevTwo('');

  }

  /**************************************End Selectize Area*****************************************************/

  constructor(public translate: TranslateService,
    private _toastService: ToastService,
    private _usersPrivilegeService: UsersPrivilegeService,
    private _location: Location,
    private _router: Router,
    private _route: ActivatedRoute,
    private _serviceSettingService: ServiceSettingService,
    private _clinicServiceService: ClinicServiceService,
    private _specialService: SpecialService) {
    this.controlsParams = new ControlsParams(3120, AppCodeGroup.Buttons, true);

  }
  ngOnInit() {
    this.getSecLogins();
  }


  /////////////////////////////////////////////
  getSecLogins() {
    this.seclogins = [];
    this.secloginLevTwo = [];
    this._usersPrivilegeService.getSecLogins()
      .subscribe(
      s => { this.allData = s.data; },
      error => console.log("unable to load helper"),
      () => {

        this.seclogins = this.allData;
        this.secloginLevTwo = this.allData;
      });
  }
  ///////////////////////
  SecLoginsId(secLogin: number) {
    this.ID = secLogin;

  }
  changeLevel(service: ServiceSetting) {
    this.parentCode = service.parentCode;
    this.levelNumber = service.levelNo;
    for (let i = this.levelBreadcrumbArray.length - 1; i > 0; i--) {

      if (service.serviceCode == this.levelBreadcrumbArray[i].serviceCode) {
        break;
      } this.clearselectize();
      this.levelBreadcrumbArray.pop();
    }
  }
  getServicesList(level: number) {
    let serviceSetting = <ServiceSetting>{};
    serviceSetting.levelNo = level;
    this._serviceSettingService.searchServicesSettingObj(serviceSetting)
      .subscribe()
  }

  getServices(pageSize = this.pageSize, offset = 0, serviceSettingKey?: string) {
    ////GET FOR SEARCH  
    if (this.serviceSettingSearchKey) {
      let serviceSetting = <ServiceSetting>{};
      //serviceSetting.levelNo = 3;
      if (this.translate.currentLang == 'en') {
        serviceSetting.nameEn = this.serviceSettingSearchKey;
      } else if (this.translate.currentLang == 'ar') {
        serviceSetting.nameAr = this.serviceSettingSearchKey;
      }
      this._serviceSettingService.searchServicesSettingObj(serviceSetting)
        .subscribe(services => {
          if (services.result) {
            console.log(services.result);
            this.services = services.result.data;
            this.totalRecords = services.paging.total;
            this.pageSize = services.paging.pageSize;
            console.log(this.services);
          }
        });


    }

  }


  paginate(offset: any) {
    this.getServices(offset.rows, offset.page);
  }

  onClicked(e: number): void {

    switch (e) {
      case 1: //save code
        this.save();
        break;
      case 3:
        this.delete();
        break;

      default:
        this.cancel();
    }
  }
  cancel() { this._location.back(); }
  delete() { }

  save() {
    this.userServiceObj = [];
    for (var i = 0; i < this.lastServicesArrayLevTwo.length; i++) {
      if (this.lastServicesArrayLevTwo[i].selected) {
        var prem: UsersService = {
          id: i + 1,
          secLoginId: this.ID,
          serviceId: this.lastServicesArrayLevTwo[i].serviceCode,
          selected: true
        };
        this.userServiceObj.push(prem);
      }

    }

    console.log(this.userServiceObj);
    this._usersPrivilegeService.addUsersService(this.userServiceObj)
      .subscribe(c => {
      });


  }

  saveLevThree(event) {
    this.userServiceObj = [];
    for (var i = 0; i < this.lastServicesArray.length; i++) {
      if (this.lastServicesArray[i].selected) {
        var prem: UsersService = {
          id: 0,
          secLoginId: this.ID,
          serviceId: this.lastServicesArray[i].serviceCode,
          selected: true
        };
        this.userServiceObj.push(prem);
      }
    }

    console.log(this.userServiceObj);
    this._usersPrivilegeService.addUsersService(this.userServiceObj)
      .subscribe(c => {
      });

  }


  reset() {
    //  this.specialSelectize.clear();
    this.specialServices = [];
    this.ngOnInit();
  }


}

